import React from "react";
import axios from "axios";
import { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";

import { accounts } from "../../utils/appConstants";
import api from "../../utils/api";

const UpdateAccountBalance = () => {
	const [data, setData] = useState({ account: "", value: "" });

	const navigate = useNavigate();
	const location = useLocation();

	const id = location.pathname.split("/")[2];

	useEffect(() => {
		const fetchAllData = async () => {
			try {
				const res = await api.get(`/money/${id}`);
				console.log(res.data);
				setData(res.data);
			} catch (err) {
				console.log(err);
			}
		};
		fetchAllData();
	}, []);

	const handleChange = (e) => {
		setData((prev) => ({ ...prev, [e.target.name]: e.target.value }));
	};

	const handleSubmit = async (e) => {
		e.preventDefault();

		console.log(data);

		try {
			await api.post(`/money/${id}`, data);
			navigate("/accountBalance");
		} catch (err) {
			console.log(err);
		}
	};

	return (
		<>
			<p>{data.id}</p>
			<select onChange={handleChange} name="account" value={data.account}>
				{accounts.map((account) => (
					<option key={account.account} value={account.account}>
						{account.account}
					</option>
				))}
			</select>
			<input type="text" placeholder="value" onChange={handleChange} name="value" value={data.value} />
			<button onClick={handleSubmit}>update</button>
		</>
	);
};

export default UpdateAccountBalance;
